export default __webpack_public_path__ + "static/media/Preferred-Sources.57746cfd.png";